import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "crmObject", "goToEditor", "linkQueryParams"];
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AssetLink(_ref) {
  let {
      children,
      crmObject,
      goToEditor,
      linkQueryParams
    } = _ref,
    linkProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const baseUrl = `/go-to/${PortalIdParser.get()}/${crmObject.objectTypeId}/${crmObject.objectId}`;
  const url = goToEditor ? `${baseUrl}/edit` : baseUrl;
  const queryParamsString = linkQueryParams ? `?${linkQueryParams}` : '';
  if (url) {
    return /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(Link, Object.assign({
        href: `${url}${queryParamsString}`,
        "data-test-id": "asset-link",
        margin: "0"
      }, linkProps, {
        children: children
      }))
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    typography: "body-100",
    as: "h1",
    children: children
  });
}